import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Grid from '../Grid';
import './styles.css';

class DetailDisplayRow extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
    data: PropTypes.any,
    dataPath: PropTypes.string,
    missingMsg: PropTypes.string,
  };

  render() {
    let { data } = this.props;
    const { label, dataPath, missingMsg } = this.props;

    if (dataPath) {
      data = get(data, dataPath, missingMsg || 'Data is missing or unknown');
    }
    return (
      <Grid.Row>
        <Grid>
          <Grid.Column styleName="label-column">
            {label}
          </Grid.Column>
          <Grid.Column styleName="data-column">
            {data}
          </Grid.Column>
        </Grid>
      </Grid.Row>
    );
  }
}

export default DetailDisplayRow;
